import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';

export const AuthContext = createContext();

const channel = new BroadcastChannel('auth_channel');

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access_token'));
  const navigate = useNavigate();
  useEffect(() => {
    channel.onmessage = (event) => {
      if (event.data === 'logout') {
        console.log('Received logout message from another tab');
        handleLocalLogout(false);
      }
      if (event.data === 'login') {
        console.log('Received login message from another tab');
        setIsAuthenticated(true);
        navigate('/dashboards');
      }
    };

    return () => {
      channel.close(); // cleanup
    };
  }, []);

  const login = (token, broadcast = true) => {
    localStorage.setItem('access_token', token);
    
    if (broadcast) {
      console.log('Broadcasting login message to other tabs');
      channel.postMessage('login');
      setIsAuthenticated(true);
    }
  };

  const handleLocalLogout = (broadcast = true) => {
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);

    if (broadcast) {
      channel.postMessage('logout');
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout: handleLocalLogout }}>
      {children}
    </AuthContext.Provider>
  );
};
